<template>
  <dash-board-layout :active="2" :title="true">
    <div class="row">
      <div class="col-xl-5 col-lg-6 col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="buy-sell-widget">
              <b-tabs class="tab-content tab-content-default">
                <b-tab
                  title="Buy"
                  class="tab-pane fade"
                  id="buy"
                  role="tabpanel"
                >
                  <currency-form />
                </b-tab>
                <b-tab title="Sell" class="tab-pane fade" id="sell">
                  <currency-form-sell />
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-7 col-lg-6 col-md-12">
        <div class="col-xl-12 col-lg-12">
          <div class="card">
            <div class="card-header border-0 pb-0">
              <h4 class="card-title">Order Activities</h4>

              <router-link class="text-primary" :to="'/order/list'"
                >View More
              </router-link>
            </div>
            <div class="card-body" style="min-height: 486px">
              <div class="transaction-table">
                <div class="table-responsive">
                  <!-- table-responsive-sm -->
                  <table class="table mb-0">
                    <tbody>
                      <tr v-for="(item, index) in data" :key="index">
                        <td>
                          <span class="buy-thumb" v-if="item.side == 'BUY'"
                            ><i class="la la-arrow-up"></i
                          ></span>
                          <span class="sold-thumb" v-if="item.side == 'SELL'"
                            ><i class="la la-arrow-down"></i
                          ></span>
                        </td>
                        <td>
                          <span
                            :class="`badge badge-${
                              item.side == 'BUY' ? 'success' : 'danger'
                            }`"
                            >{{ item.side }}</span
                          >
                        </td>
                        <td>
                          <i :class="`cc ${item.symbol}`"></i>
                          {{ item.symbol }}
                        </td>
                        <td>
                          <div
                            :title="item.order_no"
                            style="
                              width: 150px;
                              overflow: hidden;
                              white-space: nowrap;
                              text-overflow: ellipsis;
                            "
                          >
                            {{ item.order_no }}
                          </div>
                        </td>
                        <td
                          :class="`text-${
                            item.side == 'BUY' ? 'success' : 'danger'
                          }`"
                          style="text-align: right"
                        >
                          <!-- {{ item.side == "BUY" ? "+" : "-"}} -->
                          {{ formatNumber(item.coin_count, 4, ",") }}
                          {{ item.currency }}
                        </td>
                        <td style="text-align: right">
                          {{ formatNumber(item.amount, 2, ",") }}
                          {{ item.legal_currency }}
                        </td>
                        <td style="text-align: right">
                          {{ item.status }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="col-xl-7 col-lg-6 col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="buyer-seller">
              <div class="d-flex justify-content-between mb-3">
                <div class="buyer-info">
                  <div class="media">
                    <img
                      class="mr-3"
                      :src="
                        curLoginUser.avatar ||
                        `../../assets/images/profile/2.png`
                      "
                      alt=""
                      width="50"
                    />
                    <div class="media-body">
                      <h4>Buyer</h4>
                      <h5>{{ curLoginUser.realName }}</h5>
                      <a href="#">{{ curLoginUser.email }}</a>
                    </div>
                  </div>
                </div>
                <div class="seller-info text-right">
                  <div class="media">
                    <div class="media-body">
                      <h4>Seller</h4>
                      <h5>John Doe</h5>
                      <a href="#">service.otc919@outlook.com </a>
                    </div>
                    <img
                      class="ml-3"
                      src="../../assets/images/profile/1.png"
                      alt=""
                      width="50"
                    />
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table">
                  <tbody>
                    <tr>
                      <td>
                        <span class="text-primary">You are selling</span>
                      </td>
                      <td><span class="text-primary">0.00254 BTC</span></td>
                    </tr>
                    <tr>
                      <td>Payment Method</td>
                      <td>Bank of America Bank ***********5245</td>
                    </tr>
                    <tr>
                      <td>Exchange Rate</td>
                      <td>0.00212455 BTC</td>
                    </tr>
                    <tr>
                      <td>Fee</td>
                      <td>$28.00 USD</td>
                    </tr>
                    <tr>
                      <td>Total</td>
                      <td>$854.00 USD</td>
                    </tr>
                    <tr>
                      <td>Vat</td>
                      <td>
                        <div class="text-danger">$25.00 USD</div>
                      </td>
                    </tr>
                    <tr>
                      <td>Sub Total</td>
                      <td>$1232.00 USD</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <!-- <div class="row">
    </div> -->

    <div class="row" v-if="false">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">FAQ</h4>
          </div>
          <div class="card-body">
            <div id="accordion-faq" class="accordion">
              <div class="card">
                <b-card-header header-bg-variant="" v-b-toggle="'collapseOne1'">
                  <h5 class="mb-0 collapsed c-pointer">
                    <i class="fa" aria-hidden="true"></i>What Shipping Methods
                    are Available?
                  </h5>
                </b-card-header>
                <b-collapse id="collapseOne1">
                  <div class="card-body">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non cupidatat skateboard dolor brunch. Food truck
                    quinoa nesciunt laborum eiusmod.
                  </div>
                </b-collapse>
              </div>
              <div class="card">
                <b-card-header header-bg-variant="" v-b-toggle="'collapse2'">
                  <h5 class="mb-0 collapsed c-pointer">
                    <i class="fa" aria-hidden="true"></i>How Long Will it Take
                    To Get My Package?
                  </h5>
                </b-card-header>
                <b-collapse id="collapse2">
                  <div class="card-body">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non cupidatat skateboard dolor brunch. Food truck
                    quinoa nesciunt laborum eiusmod.
                  </div>
                </b-collapse>
              </div>
              <div class="card">
                <b-card-header header-bg-variant="" v-b-toggle="'collapse3'">
                  <h5 class="mb-0 collapsed c-pointer">
                    <i class="fa" aria-hidden="true"></i>How Do I Track My
                    Order?
                  </h5>
                </b-card-header>
                <b-collapse id="collapse3">
                  <div class="card-body">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non cupidatat skateboard dolor brunch. Food truck
                    quinoa nesciunt laborum eiusmod.
                  </div>
                </b-collapse>
              </div>
              <div class="card">
                <b-card-header header-bg-variant="" v-b-toggle="'collapse4'">
                  <h5 class="mb-0 collapsed c-pointer">
                    <i class="fa" aria-hidden="true"></i>Do I Need A Account To
                    Place Order?
                  </h5>
                </b-card-header>
                <b-collapse id="collapse4">
                  <div class="card-body">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non cupidatat skateboard dolor brunch. Food truck
                    quinoa nesciunt laborum eiusmod.
                  </div>
                </b-collapse>
              </div>
              <div class="card">
                <b-card-header header-bg-variant="" v-b-toggle="'collapse5'">
                  <h5 class="mb-0 collapsed c-pointer">
                    <i class="fa" aria-hidden="true"></i>How do I Place an
                    Order?
                  </h5>
                </b-card-header>
                <b-collapse id="collapse5">
                  <div class="card-body">
                    Anim pariatur cliche reprehenderit, enim eiusmod high life
                    accusamus terry richardson ad squid. 3 wolf moon officia
                    aute, non cupidatat skateboard dolor brunch. Food truck
                    quinoa nesciunt laborum eiusmod.
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-xl-6">
        <div class="intro-video-play">
          <div class="play-btn" @click="showVideo = true">
            <a class="popup-youtube c-pointer">
              <span><i class="fa fa-play"></i></span
            ></a>
          </div>
        </div>
      </div> -->
    </div>
    <videos v-show="showVideo" :closeFuntion="closeFuntion" />
  </dash-board-layout>
</template>
<script>
import CurrencyForm from "../../components/cheerio/form/CurrencyForm";
import CurrencyFormSell from "../../components/cheerio/form/CurrencyFormSell";
import Videos from "../../components/cheerio/Videos.vue";
// import { list } from "../../plugins/api/history";
import { list } from "../../plugins/api/order";
import DashBoardLayout from "../../components/layouts/DashBoardLayout.vue";
import { formatNumber } from "../../plugins/operation";
export default {
  components: { DashBoardLayout, CurrencyForm, CurrencyFormSell, Videos },
  data() {
    return {
      data: [],
      showVideo: false,
      curLoginUser: {},
    };
  },
  mounted() {
    this.getdata();
  },
  created() {
    this.curLoginUser = this.$store.getters.curLoginUser;
  },
  methods: {
    formatNumber(num1, length, sp) {
      return formatNumber(num1, length, sp);
    },
    closeFuntion() {
      this.showVideo = false;
    },
    getdata() {
      list({ page: 1, per_page: 5 }).then((res) => {
        if (res.code == 0) {
          this.data = res.data;
        }
      });
    },
  },
};
</script>
